import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterOptions',
  standalone:true
})
export class FilterOptionsPipe implements PipeTransform {
  transform(options: any[], searchTerm: string, searchProperty: string): any[] {
    if (!options || !searchTerm) {
      return options;
    }

    searchTerm = searchTerm.toLowerCase().trim();

    return options.filter(option => {
      if (option?.hasOwnProperty(searchProperty)) {
        return option[searchProperty].toLowerCase().includes(searchTerm);
      }
      return false;
    });
  }
}
